// src/components/ResumeBuilder/forms/HobbiesForm.jsx
import React, { useContext } from "react";
import {
  Box,
  Card,
  Grid,
  TextField,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { FieldArray, Formik, Form } from "formik";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import GradientButton from "../Button";
import { ResumeContext } from "../../ResumeContext";
import { saveResumeData } from "../../api/resumeapi";
import BasicInfoSkeleton from "./skeletonLoader";
import { HobbiesSchema } from "./resumevalidation";

export default function HobbiesForm({ onNext }) {
  const { data, setData, loading } = useContext(ResumeContext);

  // ✅ Skeleton while loading
  if (loading || !data) {
    return <BasicInfoSkeleton />;
  }

  return (
    <Card sx={{ p: 3, borderRadius: 2, boxShadow: 2 }}>
      <Typography fontSize={13} color="#6E6D81" mb={2}>
        What keeps you alive other than work?
      </Typography>

      <Formik
        enableReinitialize
        initialValues={{
          hobbies:
            Array.isArray(data?.hobbies) && data.hobbies.length > 0
              ? data.hobbies
              : [""],
        }}
        validationSchema={HobbiesSchema}
        validateOnBlur
        validateOnChange
        onSubmit={async (values) => {
          const hobbies = values.hobbies.filter(
            (h) => h && h.trim() !== ""
          );

          const payload = {
            ...data,
            hobbies,
          };

          try {
            // SAVE TO DB
            await saveResumeData(payload);

            // UPDATE CONTEXT
            setData((prev) => ({
              ...prev,
              hobbies,
            }));
          } catch (err) {
            console.error("HOBBIES SAVE ERROR:", err);
          }
        }}
      >
        {({
          values,
          handleChange,
          errors,
          touched,
          setTouched,
        }) => (
          <Form>
            <FieldArray name="hobbies">
              {({ push, remove }) => (
                <Box>
                  {values.hobbies.map((hobby, idx) => (
                    <Grid
                      container
                      spacing={2}
                      key={idx}
                      alignItems="center"
                      sx={{ mb: 1 }}
                    >
                      <Grid size={{ xs: 12, sm: 10 }}>
                        <TextField
                          fullWidth
                          label={`Hobby #${idx + 1}`}
                          name={`hobbies[${idx}]`}
                          size="small"
                          value={hobby}
                          onChange={handleChange}
                          error={
                            touched.hobbies?.[idx] &&
                            Boolean(errors.hobbies?.[idx])
                          }
                          helperText={
                            touched.hobbies?.[idx] &&
                            errors.hobbies?.[idx]
                          }
                        />
                      </Grid>

                      <Grid size={{ xs: 12, sm: 2 }} textAlign="right">
                        <IconButton
                          onClick={() => remove(idx)}
                          disabled={values.hobbies.length === 1}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}

                  <Button
                    startIcon={<AddIcon />}
                    onClick={() => push("")}
                  >
                    Add hobby
                  </Button>
                </Box>
              )}
            </FieldArray>

            {/* BUTTONS */}
            <Box mt={3} display="flex" justifyContent="center" gap={4}>
              <GradientButton
                type="button"
                onClick={onNext}
              >
                Next
              </GradientButton>

              <GradientButton
                type="submit"
                onClick={() =>
                  setTouched(
                    {
                      hobbies: values.hobbies.map(() => true),
                    },
                    true
                  )
                }
              >
                Save
              </GradientButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Card>
  );
}
